import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 640",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M140.8 428.8C148.9 438.9 150.2 452.9 144 464.2L103.8 537.8L204.8 494.5C212.7 491.1 221.6 491 229.6 494.3C257.2 505.6 287.8 511.9 320 511.9C445.7 511.9 544 416.9 544 303.9C544 190.9 445.7 96 320 96C194.3 96 96 191 96 304C96 350.7 112.5 393.8 140.8 428.8zM115.9 448.9C83.3 408.6 64 358.4 64 304C64 171.5 178.6 64 320 64C461.4 64 576 171.5 576 304C576 436.5 461.4 544 320 544C283.5 544 248.8 536.8 217.4 524L101 573.9C97.3 575.5 93.5 576 89.5 576C75.4 576 64 564.6 64 550.5C64 546.2 65.1 542 67.1 538.3L115.9 448.9z" })
});
export default SvgComment;
